import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export interface Announcement {
  announcement_id: number
  provider_id: number
  title: string
  content: string
  target_type: 'clinic' | 'ad_supplier' | 'all'
  is_active: boolean
  sort_order: number
  created_by: number | null
  created_at: string
  updated_at: string
}

interface AnnouncementsResponse {
  success: boolean
  data: Announcement[]
  total: number
}

interface UseAnnouncementsParams {
  page?: number
  pageSize?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  targetType?: string
  isActive?: string
  providerId?: number | null
}

export function useAnnouncements(params?: UseAnnouncementsParams) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  if (params?.page) queryParams.set('page', String(params.page))
  if (params?.pageSize) queryParams.set('pageSize', String(params.pageSize))
  if (params?.sortBy) queryParams.set('sortBy', params.sortBy)
  if (params?.sortOrder) queryParams.set('sortOrder', params.sortOrder)
  if (params?.targetType) queryParams.set('targetType', params.targetType)
  if (params?.isActive !== undefined) queryParams.set('isActive', params.isActive)
  if (params?.providerId) queryParams.set('providerId', String(params.providerId))
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate } = useGet<AnnouncementsResponse>(
    token ? `/api/announcements${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    announcements: data?.data || [],
    total: data?.total || 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
